<template>
  <div class="success-page">
    <van-icon class="success-icon" name="success" size="5rem" color="#07c160" />
    <div class="success-text">提交成功！</div>
    <div class="message-text">{{ message }}</div>
    <van-button type="primary" @click="backToForm">返回表单</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: this.$route.query.message || ''
    };
  },
  methods: {
    backToForm() {
      // 返回表单页的操作，可以是路由跳转或其他操作
      this.$router.push('/staff/add')
    }
  }
};
</script>

<style scoped>
.success-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.success-icon {
  margin-bottom: 20px;
}

.success-text {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.message-text {
  font-size: 1rem;
  margin-bottom: 30px;
  color: #666;
}
</style>
